import { NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CustomDynamicFormControlComponent } from '../custom-dynamic-form-control.component';
import { ActionButtonModel } from './action-button.model';

@Component({
  selector:    'gsm-action-button',
  templateUrl: './action-button.component.html',
  styleUrls:   ['./action-button.component.scss'],
  standalone:  true,
  imports:     [
    NgIf,
    MatIconButton,
    MatIcon
  ]
})
export class ActionButtonComponent extends CustomDynamicFormControlComponent<ActionButtonModel> implements OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  onClick() {
    this.customEvent.emit({
      customEvent:     new CustomEvent(this.model.eventName),
      customEventType: this.model.eventName
    });
  }

  get isHidden(): boolean {
    return this.model.disabled && this.model.hiddenWhenDisabled;
  }
}
